import React from 'react'
import { useTranslation } from 'react-i18next'
import { Receipt } from 'src/services/receipts'
import { Button } from 'src/components/button'
import { EyeIcon } from '@heroicons/react/24/outline'
import { ReceiptListItemActionWrapper } from '../receipts/receipt-list-item-action-wrapper'

interface ExpenseSidebarActionWrapperProps {
  receipt: Receipt
  onView: (receipt: Receipt) => void
}

export const ExpenseSidebarActionWrapper: React.FC<ExpenseSidebarActionWrapperProps> = ({
  receipt,
  onView,
}) => {
  const { t } = useTranslation()
  return (
    <ReceiptListItemActionWrapper
      receipt={receipt}
      actions={
        <Button
          onClick={() => onView(receipt)}
          variant="unstyled"
          data-testid="view-button"
          title={t('receipts.viewReceipt')}
        >
          <EyeIcon className="h-4 w-4" />
        </Button>
      }
    />
  )
}
